module.exports = __webpack_public_path__ + "static/media/moscudll_128.e434eea8.ico";